import React from "react";
import { Modal, Box, Fade } from "@mui/material";

const PreviewImageModal = ({ isOpen, onRequestClose, previewImagePath }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      closeAfterTransition
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(5px)",
        },
      }}
    >
      <Fade in={isOpen}>
        <Box
          onClick={onRequestClose}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            outline: "none",
          }}
        >
          <img
            src={previewImagePath}
            alt="Preview"
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: "0px",
              boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
              transform: isOpen ? "scale(1)" : "scale(0.8)",
              transition: "transform 0.3s ease-out",
            }}
          />
        </Box>
      </Fade>
    </Modal>
  );
};

export default PreviewImageModal;
